import { Input } from 'antd';
import { withValueCap } from 'pages/globals/global';

export const ifrs16Config = {
	// Table styles for consistent appearance
	tableContainerStyles: {
		width: '100%',
		overflowX: 'auto',
		position: 'relative',
		display: 'block',
		'& td, & th': { whiteSpace: 'nowrap' },
		'& td': {
			borderTop: '0px',
			borderLeft: '0px',
			borderBottom: '0px',
		},
		'& td:not(:last-child)': {
			borderRight: '1px solid #e0e0e0',
		},
		'& tr:not(:last-child)': {
			borderBottom: '1px solid #e0e0e0',
		},
		'& th': {
			borderBottom: '1px solid #e0e0e0',
		},
	},

	tableStyles: {
		'& .MuiTableBody-root .MuiTableCell-root': {
			px: 0.5,
			py: 0.5,
		},
		tableLayout: 'fixed',
	},

	// Cell configurations for each column type
	cellConfigs: {
		effectiveDate: {
			key: 'inputChangeEffectiveDate',
			component: {
				type: 'datePicker',
				props: {
					format: 'YYYY-MM-DD',
					style: {
						width: '100%',
						height: '32px',
					},
					className: 'antd-datePicker',
				},
			},
		},
		retirementDate: {
			key: 'inputChangeRetirementDate',
			component: {
				type: 'datePicker',
				props: {
					format: 'YYYY-MM-DD',
					style: {
						width: '100%',
						height: '32px',
					},
					className: 'antd-datePicker',
				},
			},
		},
		retirementTerm: {
			key: 'inputChangeRetirementTerm',
			component: {
				type: 'input',
				props: {
					type: 'number',
					style: {
						marginBottom: 0,
						textAlign: 'center',
					},
					disabled: true,
				},
			},
		},
		discountRate: {
			key: 'inputChangeDiscountRate',
			component: {
				type: 'numericFormat',
				props: {
					size: 'large',
					decimalScale: 2,
					placeholder: '0.00',
					fixedDecimalScale: true,
					thousandSeparator: ',',
					isAllowed: withValueCap,
					style: {
						textAlign: 'center',
						height: '32px',
						borderRadius: '4px',
						fontSize: '13px',
					},
					customInput: Input,
				},
			},
		},
		retirementCost: {
			key: 'inputChangeRetirementCost',
			component: {
				type: 'numericFormat',
				props: {
					size: 'large',
					decimalScale: 2,
					placeholder: '0.00',
					fixedDecimalScale: true,
					thousandSeparator: ',',
					isAllowed: withValueCap,
					style: {
						textAlign: 'center',
						height: '32px',
						borderRadius: '4px',
						fontSize: '13px',
					},
					customInput: Input,
				},
			},
		},
		// grossAmount: {
		// 	key: 'inputChangeGrossAmount',
		// 	component: {
		// 		type: 'numericFormat',
		// 		props: {
		// 			disabled: true, // Always disabled since not in form UI
		// 			size: 'large',
		// 			decimalScale: 2,
		// 			placeholder: '0.00',
		// 			fixedDecimalScale: true,
		// 			thousandSeparator: ',',
		// 			isAllowed: withValueCap,
		// 			style: {
		// 				textAlign: 'center',
		// 				height: '32px',
		// 				borderRadius: '4px',
		// 				fontSize: '13px',
		// 			},
		// 			customInput: Input,
		// 		},
		// 	},
		// },
		// escalation: {
		// 	key: 'inputChangeEscalation',
		// 	component: {
		// 		type: 'numericFormat',
		// 		props: {
		// 			disabled: true, // Always disabled since not in form UI
		// 			size: 'large',
		// 			decimalScale: 2,
		// 			placeholder: '0.00',
		// 			fixedDecimalScale: true,
		// 			thousandSeparator: ',',
		// 			isAllowed: withValueCap,
		// 			style: {
		// 				textAlign: 'center',
		// 				height: '32px',
		// 				borderRadius: '4px',
		// 				fontSize: '13px',
		// 			},
		// 			customInput: Input,
		// 		},
		// 	},
		// },
		// paymentFrequency: {
		// 	key: 'paymentFrequency',
		// 	component: {
		// 		type: 'select',
		// 		props: {
		// 			disabled: true, // Always disabled since not in form UI
		// 			showSearch: true,
		// 			style: {
		// 				textAlign: 'center',
		// 			},
		// 			filterOption: true,
		// 		},
		// 	},
		// },
		// paymentTime: {
		// 	key: 'paymentTime',
		// 	component: {
		// 		type: 'select',
		// 		props: {
		// 			disabled: true, // Always disabled since not in form UI
		// 			showSearch: true,
		// 			style: {
		// 				textAlign: 'center',
		// 			},
		// 			filterOption: true,
		// 		},
		// 	},
		// },
		description: {
			key: 'inputChangeDescription',
			component: {
				type: 'select',
				props: {
					disabled: true, // Always disabled since not editable in form UI
					showSearch: true,
					style: {
						textAlign: 'center',
					},
					filterOption: true,
				},
			},
		},
	},

	// Helper functions
	getColorBasedOnChange: (form, index, fieldName) => {
		if (index === 0) return 'black';

		const currentValue = form.getFieldValue(['changes', index, fieldName]);
		const previousValue = form.getFieldValue(['changes', index - 1, fieldName]);

		return currentValue === previousValue ? 'black' : 'blue';
	},

	isFieldDisabled: (index, screen, rowIndex, isFirstRow = false) => {
		if (isFirstRow && index === 0) return true;
		if (screen === 'VIEW') return true;
		if (screen !== 'CREATE' && index < rowIndex) return true;
		return false;
	},
};
